import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { AccountUpdate } from './account.model';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient) {}

  updateAccount(account: AccountUpdate): Observable<HttpResponse<AccountUpdate>> {
    return this.http.post<AccountUpdate>('/api/Account/UpdateAccount', account, { observe: 'response' });
  }

  resendTermsOfService(): Promise<void> {
    return lastValueFrom(this.http.post<void>('/api/ToS/ResendToS', null));
  }
}